export const samplesTypes = [
  'Free Sample',
  'Chart IQ',
  'Backtesting',
  'Data Analytics',
]
